import { render, staticRenderFns } from "./Dep.vue?vue&type=template&id=04b03524&scoped=true&"
import script from "./Dep.vue?vue&type=script&lang=js&"
export * from "./Dep.vue?vue&type=script&lang=js&"
import style0 from "./Dep.vue?vue&type=style&index=0&id=04b03524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b03524",
  null
  
)

export default component.exports